export default "__VITE_ASSET__Dp6PvKeQ__"